var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLienAmount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27,
    r: 27,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4943 36.5897L21.911 30.173C21.9227 30.1613 21.9343 30.1613 21.946 30.1497C21.211 29.6363 20.3127 29.333 19.3327 29.333C16.7543 29.333 14.666 31.4213 14.666 33.9997C14.666 34.8747 14.911 35.703 15.3427 36.403C15.3893 36.473 15.436 36.543 15.4827 36.613C15.4943 36.6013 15.4943 36.5897 15.4943 36.5897Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1607 31.41L16.744 37.8267C16.7323 37.8383 16.7207 37.8383 16.709 37.85C17.4557 38.3633 18.354 38.6667 19.334 38.6667C21.0373 38.6667 22.519 37.7567 23.324 36.4033C23.7557 35.7033 24.0007 34.875 24.0007 34C24.0007 33.02 23.6973 32.1217 23.184 31.375C23.1723 31.3867 23.1723 31.3983 23.1607 31.41Z",
    fill: "#9747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6673 17.667C18.1673 17.667 15.834 19.417 15.834 23.5003V27.6537C15.834 28.0853 16.2773 28.3537 16.6623 28.1787C17.8057 27.6537 19.124 27.4553 20.5123 27.7003C23.5807 28.2487 25.8323 31.0953 25.7507 34.2103C25.739 34.7003 25.669 35.1787 25.5407 35.6453C25.4473 36.007 25.739 36.3453 26.1123 36.3453H33.334C36.834 36.3453 39.1673 34.5953 39.1673 30.512V23.5003C39.1673 19.417 36.834 17.667 33.334 17.667H21.6673ZM24.584 27.0003C24.584 25.3903 25.8907 24.0837 27.5007 24.0837C29.1107 24.0837 30.4173 25.3903 30.4173 27.0003C30.4173 28.6103 29.1107 29.917 27.5007 29.917C25.8907 29.917 24.584 28.6103 24.584 27.0003ZM35.084 30.2087C34.6057 30.2087 34.209 29.812 34.209 29.3337V24.667C34.209 24.1887 34.6057 23.792 35.084 23.792C35.5623 23.792 35.959 24.1887 35.959 24.667V29.3337C35.959 29.812 35.5623 30.2087 35.084 30.2087Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLienAmount);
export default __webpack_public_path__ + "static/media/LienAmount.479f75f48810c55d5570a353b38ce115.svg";
export { ForwardRef as ReactComponent };